import React, { useState } from "react";
import "./styles/Pricing.css";
import GreenCheckMark from "./components/green-checkmark.js";
import BrownCheckMark from "./components/brown-checkmark.js";

const Pricing = () => {
  const [isYearly, setIsYearly] = useState(true);

  const togglePricing = () => {
    setIsYearly(!isYearly);
  };

  return (
    <div className="pricing-container">
      <h1 className="pricing-title">Plans & Pricing</h1>
      <p className="pricing-description">
        Experience the full power of ExploreEase with one trip free. Upgrade
        anytime for unlimited adventures.
      </p>
      <div className="toggle-container">
        <div className={`toggle-label ${!isYearly ? "active" : ""}`}>
          Monthly
        </div>
        <div
          className={`toggle ${isYearly ? "yearly" : ""}`}
          onClick={togglePricing}
        >
          <div
            className={`toggle-button ${isYearly ? "yearly" : "monthly"}`}
          ></div>
        </div>
        <div className={`toggle-label ${isYearly ? "active" : ""}`}>Yearly</div>
      </div>
      <div className="plans">
        <div className="plan basic">
          <div className="plan-price basic-price">
            <h2>Free</h2>
            <p className="price">$0</p>
          </div>
          <ul>
            <div>
              <BrownCheckMark />
              <li>
                <strong>1 trip with full features</strong>
              </li>
            </div>
            <div>
              <BrownCheckMark />
              <li>AI-powered smart packing assistant</li>
            </div>
            <div>
              <BrownCheckMark />
              <li>Daily trip insights & personalized tips</li>
            </div>
            <div>
              <BrownCheckMark />
              <li>Budget tracker with auto-settlement calculator</li>
            </div>
            <div>
              <BrownCheckMark />
              <li>Travel journal with guided prompts & mood tracking</li>
            </div>
            <div>
              <BrownCheckMark />
              <li>Auto-organized memory timeline</li>
            </div>
            <div>
              <BrownCheckMark />
              <li>Translator & destination-specific key phrases</li>
            </div>
            <div>
              <BrownCheckMark />
              <li>Live exchange rates & currency converter</li>
            </div>
            <div>
              <BrownCheckMark />
              <li>Travel trivia & cultural discoveries</li>
            </div>
            <div>
              <BrownCheckMark />
              <li>Curated playbooks & custom itineraries</li>
            </div>
          </ul>
        </div>
        <div className="plan premium">
          <div className="plan-price premium-price">
            <h2>Pro</h2>
            <p className="price">{isYearly ? "$39.99/year" : "$4.99/month"}</p>
          </div>
          {isYearly && (
            <p className="plan-subtitle">
              <span className="savings">Save $20/year!</span>
            </p>
          )}
          <ul>
            <div>
              <GreenCheckMark />
              <li>
                <strong>Unlimited trips</strong>
              </li>
            </div>
            <div>
              <GreenCheckMark />
              <li>AI-powered smart packing assistant</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Daily trip insights & personalized tips</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Budget tracker with auto-settlement calculator</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Travel journal with guided prompts & mood tracking</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Auto-organized memory timeline</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Translator & destination-specific key phrases</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Live exchange rates & currency converter</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Travel trivia & cultural discoveries</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Curated playbooks & custom itineraries</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Priority support & early feature access</li>
            </div>
            <div>
              <GreenCheckMark />
              <li>Export & backup all trip data</li>
            </div>
          </ul>
        </div>
      </div>
      <div className="pricing-comparison-note">
        <p>
          <strong>Why upgrade?</strong> Love ExploreEase after your first trip?
          Unlock unlimited adventures and never lose your travel memories. Pro
          users get all features for every trip, plus priority support.
        </p>
      </div>
      <p className="pricing-note">
        Start your journey today with ExploreEase—experience the full power of
        AI-driven travel management with your first trip completely free.
      </p>
    </div>
  );
};

export default Pricing;
